// extracted by mini-css-extract-plugin
export var root = "TeamContent-root-LwOqX";
export var rootDescription = "TeamContent-root_description-9Q5aE";
export var rootDescriptionBottom = "TeamContent-root_descriptionBottom-M1Xsm";
export var rootHeading = "TeamContent-root_heading-pGZ+s";
export var rootImage = "TeamContent-root_image-VF-Ef";
export var rootPicture = "TeamContent-root_picture-+mL02";